{
    "coordinates": [
        49.521838860157914,
        7.4402019682614196
    ],
    "tooltip": "Remigiusberg",
    "title": "Remigiusberg Formation",
    "country": "Germany",
    "period": "Permian",
    "alt": "TODO"
}
